import {
  CollectionCategoryType,
  SurveyAnswerProduct
} from '@src/generated/hooks';

// We don't input all the categories yet, so omit the ones we aren't using.
export type SurveyedCategoriesType = Exclude<
  CollectionCategoryType,
  'body' | 'eye_care' | 'face_scrub' | 'retinol' | 'holiday_store'
>;

export const SURVEY_CATEGORIES_MORNING: SurveyedCategoriesType[] = [
  'cleanser',
  'toner_hydrator',
  'serum',
  'moisturizer',
  'sunscreen',
  'other'
];

export const SURVEY_CATEGORIES_EVENING: SurveyedCategoriesType[] = [
  'cleanser',
  'exfoliator',
  'toner_hydrator',
  'serum',
  'face_oil',
  'moisturizer',
  'acne',
  'mask',
  'other'
];

export const SURVEY_CATEGORY_FILTERS: Record<
  SurveyedCategoriesType,
  CollectionCategoryType[]
> = {
  acne: ['acne', 'exfoliator', 'retinol', 'serum'],
  cleanser: ['cleanser', 'exfoliator', 'face_scrub', 'toner_hydrator'],
  exfoliator: ['acne', 'cleanser', 'exfoliator', 'face_scrub', 'retinol', 'serum', 'toner_hydrator'], // prettier-ignore
  face_oil: ['face_oil', 'moisturizer', 'serum', 'toner_hydrator'],
  mask: ['mask'],
  moisturizer: ['face_oil', 'moisturizer', 'sunscreen'],
  other: [],
  serum: ['acne', 'exfoliator', 'face_oil', 'retinol', 'serum'],
  sunscreen: ['moisturizer', 'sunscreen'],
  toner_hydrator: ['cleanser', 'exfoliator', 'toner_hydrator']
};

export const SURVEY_ROUTINE_REDIRECT = '/routine';

export const SURVEY_ROUTINE_PRODUCT: SurveyAnswerProduct = {
  category: 'other',
  product_id: '',
  text: '',
  time_of_day: 'morning'
};
